interface FullStoryUserVars {
  displayName: string;
  email: string;
  [key: string]: unknown;
}

export function identifyUser(uid: string, userVars: FullStoryUserVars): void {
  window.FS?.identify(uid, userVars);
}